<template>
	<div>
		<div class="card">
			<div class="card-body">
				<div class="row d-flex align-items-center">
					<div class="col-12 col-lg-6 col-xl-4 mb-3 mb-lg-0 d-flex align-items-center">
						<div>
							<g-avatar
								:size="100"
								font-size="28"
								class="mr-4"
								:color="$colors.orange"
								:name="item.EmpresaNombre"
							/>
						</div>

						<div>
							<h1 :class="$style.h1">
								{{ item.EmpresaNombreComercial }}
							</h1>
							<h2 :class="$style.h2">
								{{ item.EmpresaNombre }}
							</h2>
						</div>
					</div>

					<div
						class="col-12 col-lg-6 col-xl-4 mb-3 mb-lg-0"
						:class="$style.contactBox"
					>
						<h3 :class="$style.h3">
							Información de contacto
						</h3>

						<div :class="$style.contactItem">
							<fa-icon
								:icon="['far','envelope']"
								class="mr-2"
							/> {{ item.EmpresaEmail || 'Sin definir' }}
						</div>
						<div :class="$style.contactItem">
							<fa-icon
								:icon="['far','phone']"
								class="mr-2"
							/>
							{{ item.EmpresaTelefono || 'Sin definir' }}
						</div>
						<div :class="$style.contactItem">
							<fa-icon
								:icon="['far','map-marker']"
								class="mr-2"
							/>
							{{ address[0] }}<br>{{ address[1] }}
						</div>
					</div>

					<div
						class="col-12 col-xl-4 flex-grow"
						:class="$style.salesBox"
					>
						<h3 :class="$style.h3">
							Ventas
						</h3>
					</div>
				</div>
			</div>

			<div class="card-footer p-0">
				<div :class="$style.tabs">
					<a
						:class="[$style.tab, tab === 1 ? $style.active : '']"
						@click="tab = 1"
					>
						<fa-icon
							:icon="['far','tachometer-alt-fast']"
							class="mr-2"
						/>

						General
					</a>
					<a
						:class="[$style.tab, tab === 2 ? $style.active : '']"
						@click="tab = 2"
					>
						<fa-icon
							:icon="['far','comment-alt-dots']"
							class="mr-2"
						/> Comentarios
					</a>
					<div class="ml-auto" />
					<a
						:class="[$style.tab, tab === 4 ? $style.active : '']"
						@click="tab = 4"
					>
						<fa-icon
							:icon="['far','cog']"
							class="mr-2"
						/> Configuración
					</a>
				</div>
			</div>
		</div>

		<div
			v-show="tab === 1"
		>
			<div class="row">
				<div class="col-12 col-xl-8">
					<info v-model="item" />
				</div>

				<div class="col-12 col-xl-4">
					<transition
						name="slide-fadein-left"
						mode="out-in"
					>
						<div
							v-if="mapPosition"
							class="card"
						>
							<div class="card-header py-3 bold text-uppercase text-dark">
								<fa-icon
									icon="map-marker"
									class="mr-2"
								/> Mapa
							</div>

							<div class="card-body p-0">
								<gmap-map
									ref="map"
									:center="mapCenter"
									:zoom="12"
									:options="mapOptions"
									style="width: 100%; height: 300px"
								>
									<gmap-marker
										:position="mapPosition"
										:clickable="true"
										:draggable="false"
										@click="$refs.map.$mapObject.setCenter(mapPosition)"
									/>
								</gmap-map>
							</div>
						</div>
					</transition>

					<transition
						name="slide-fadein-left"
						mode="out-in"
					>
						<invoice-list
							:id="item._EntityId"
							:limit="3"
						/>
					</transition>

					<transition
						name="slide-fadein-left"
						mode="out-in"
					>
						<budget-list
							:id="item._EntityId"
							:limit="3"
						/>
					</transition>
				</div>
			</div>
		</div>

		<div
			v-show="tab === 2"
			class="card"
		>
			<div class="card-body">
				2
			</div>
		</div>

		<div v-show="tab === 4">
			<edit v-model="item" />
		</div>

		<div class="row" />
	</div>
</template>

<script>
import edit from './_edit';
import info from './_info';

export default {
	name: 'EmpresasView',
	components: { edit, info },
	data() {
		return {
			id: 0,
			tab: 1,
			item: {
				_EntityId: 0,
				EmpresaNombre: '',
				EmpresaNombreComercial: '',
				EmpresaEmail: '',
				EmpresaTelefono: ''
			},
			mapOptions: {
				zoomControl: true,
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: true,
				fullscreenControl: true,
				disableDefaultUi: false,
				scrollwheel: false
			},
			mapCenter: null,
			mapPosition: null
		};
	},
	computed: {
		address() {
			if (this.item) {
				return [
					this.item.EmpresaDomicilioSocial,
					[this.item.EmpresaCP, this.item.EmpresaLocalidad, this.item.EmpresaProvincia].join(', ').trim()
				];
			}

			return 'Sin definir';
		}
	},
	watch: {
		'$route.params.id': function () {
			this.id = this.$route.params.id || 0;
			if (this.id) this.init();
		}
	},
	async created() {
		this.id = this.$route.params.id || 0;

		if (this.id) await this.init();
	},
	methods: {
		async init() {
			const result = await this.$gestios.items('empresas').get(this.id);

			if (result.ok) {
				this.item = result.data;
				this.loadMap();
				return true;
			}

			this.$router.replace({ name: '_404' });
			return false;
		},
		loadMap() {
			if (this.item.EmpresaDomicilioSocial) {
				const geocoder = new google.maps.Geocoder();

				geocoder.geocode({
					address: this.item.EmpresaDomicilioSocial
				}, (results) => {
					this.mapPosition = {
						lat: results[0].geometry.location.lat(),
						lng: results[0].geometry.location.lng()
					};

					this.mapCenter = this.mapPosition;
				});
			}
		}
	}
};
</script>

<style lang="scss" module>
@import '@/application/assets/scss/clients.scss'
</style>

<style lang="scss">
@import '@/application/assets/scss/invoices.scss'
</style>
